export enum Modal {
  AddPaymentMethod = 'ADD_PAYMENT_METHOD',
  ConfirmPaymentMethodRemoval = 'CONFIRM_PAYMENT_METHOD_REMOVAL',
}

export enum AppError {
  FetchingMethodsListFailed = 'FETCHING_METHODS_LIST_FAILED',
}

export enum Interaction {
  OpenSettingsPanel = 'open-settings-panel',
  MarkAsPrimary = 'mark-pm-as-primary',
  RemovePaymentMethod = 'remove-pm',
  LoadRemovalModal = 'load-remove-pm-modal',
  LoadAddPaymentMethodModal = 'load-add-pm-modal',
  LoadPaymentMethods = 'load-saved-pms',
  LoadRecurringPaymentMethods = 'load-recurring-pms',
  InitializePaymentsWidget = 'init-cashier-payments-widget',
}
